import {
  MOBILE_APP_PLATFORM_ANDROID,
  MOBILE_APP_PLATFORM_IOS,
} from './constants';
import type { MobileAppPlatform } from './types';

export const isMobileAppPlatform = (
  value: unknown,
): value is MobileAppPlatform => (
  typeof value === 'string'
  && [MOBILE_APP_PLATFORM_ANDROID, MOBILE_APP_PLATFORM_IOS].includes(value)
);

export const willScrollUpOrDown = (targetElement: HTMLElement, container = document.documentElement) => {
  const targetTop = targetElement.getBoundingClientRect().top + container.scrollTop;
  const currentScrollTop = container.scrollTop;

  if (targetTop < currentScrollTop) {
    return 'up';
  }

  if (targetTop > currentScrollTop) {
    return 'down';
  }
  return 'none';
};
